import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormattedText from '@/components/shared/FormattedText';
import ClampText from '@/components/shared/ClampText';

const Introduction = ({ idolInfo }) => {
    const { t } = useTranslation();

    const getTranslatedValue = (value) => {
        if (!value) return value;
        const key = String(value).toLowerCase();
        const translated = t(key);
        return translated !== key ? translated : value;
    };

    const basicInfoItems = [
        { label: 'age', value: idolInfo.age },
        { label: 'height', value: idolInfo.height },
        { label: 'weight', value: idolInfo.body_type },
        { label: 'gender', value: getTranslatedValue(idolInfo.gender) },
        { label: 'sexual_orientation', value: getTranslatedValue(idolInfo.sexual_orientation) },
        { label: 'relationship_status', value: getTranslatedValue(idolInfo.relationship_status) },
        { label: 'content_type', value: getTranslatedValue(idolInfo.preferences) }
    ];

    const booleanInfoItems = [
        { label: 'idol_is_it_official', value: idolInfo.is_official ? 'True' : 'False' },
        { label: 'idol_is_it_original', value: idolInfo.is_original ? 'True' : 'False' },
        { label: 'idol_is_nsfw', value: idolInfo.is_nsfw ? 'True' : 'False' }
    ];

    const longInfoItems = [
        { label: 'education', value: idolInfo.education },
        { label: 'occupation', value: idolInfo.occupation },
        { label: 'interest', value: idolInfo.interests },
    ];

    return (
        <div>
            {/* 關於我 */}
            <h5 className="mb-3">{t('aboutme')}</h5>

            <div className="row g-2">
                {basicInfoItems.map((item, index) => (
                    <div key={index} className="col-12">
                        <div className="d-flex flex-wrap">
                            <div className="bg-light p-2 rounded-start intro-label">
                                <h6 className="mb-0 fw-semibold">{t(item.label)}</h6>
                            </div>
                            <div className="p-2 flex-grow-1 rounded-end">
                                <p className="mb-0 text-break">{item.value || 'N/A'}</p>
                            </div>
                        </div>
                    </div>
                ))}

                {booleanInfoItems.map((item, index) => (
                    <div key={index} className="col-12">
                        <div className="d-flex flex-wrap">
                            <div className="bg-light p-2 rounded-start intro-label">
                                <h6 className="mb-0 fw-semibold">{t(item.label)}</h6>
                            </div>
                            <div className="p-2 flex-grow-1 rounded-end d-flex align-items-center">
                                {item.value === 'True' ? (
                                    <FontAwesomeIcon icon={['far', 'circle-check']} className="text-primary fs-5" />
                                ) : (
                                    <FontAwesomeIcon icon={['far', 'circle-xmark']} className="text-neutral fs-5" />
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                {longInfoItems.map((item, index) => (
                    <div key={index} className="col-12">
                        <div className="d-flex flex-wrap">
                            <div className="bg-light p-2 rounded-start intro-label w-100">
                                <h6 className="mb-0 fw-semibold">{t(item.label)}</h6>
                            </div>
                            <div className="p-2 flex-grow-1 rounded-end">
                                <FormattedText text={item.value || 'N/A'} className="mb-0 text-break" />
                            </div>
                        </div>
                    </div>
                ))}

                {idolInfo.idol_bio && (
                    <div className="col-12">
                        <div className="bg-light p-2 rounded-start intro-label w-100">
                            <h6 className="mb-0 fw-semibold">{t('bio')}</h6>
                        </div>
                        <div className="p-2">
                            <ClampText
                                text={idolInfo.idol_bio}
                                clampClassName="intro-text-container"
                                className="mb-0 text-break"
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* AI Prompt */}
            {idolInfo.prompt_word && (
                <div className="row g-2 mt-2">
                    <div className="col-12">
                        <div className="bg-light p-2 rounded-start intro-label w-100">
                            <h6 className="mb-0 fw-semibold">{t('prompt_word')}</h6>
                        </div>
                        <div className="p-2">
                            <ClampText
                                text={idolInfo.prompt_word}
                                clampClassName="intro-text-container"
                                className="mb-0 text-break"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Introduction
